import React from 'react'
import { CheckboxField as ShellCheckboxField } from '@e3dc-react/shell/Elements/InputFields'
import { CheckboxFieldProps } from '@e3dc-react/shell/Elements/InputFields/checkbox/CheckboxField'
import { Controller, useFormContext } from 'react-hook-form'

type Props = {
  name: string
} & Omit<CheckboxFieldProps<boolean>, 'name'>

/**
 * Checkbox input integrated with react-hook-form
 */
const Checkbox: React.FC<Props> = ({ name, ...props }) => {
  const { control } = useFormContext()

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => <ShellCheckboxField {...field} {...props} error={!!error} helperText={error?.message} />}
    />
  )
}

export default Checkbox
